import { createContext, useContext } from 'react'
import type { TableDensity } from './types'

/**
 * Mặc định của tài khoản (Cài đặt › Hiển thị & mặc định) cho mọi bảng. `MainLayout` cấp qua `PreferencesGate`.
 * Thứ tự ưu tiên: lựa chọn riêng của bảng (localStorage) → `defaultPageSize` màn tự khai → tài khoản → hệ thống.
 */
export interface TableDefaults {
  density: TableDensity | null
  pageSize: number | null
}

const TableDefaultsContext = createContext<TableDefaults>({ density: null, pageSize: null })

export const TableDefaultsProvider = TableDefaultsContext.Provider
export const useTableDefaults = () => useContext(TableDefaultsContext)
